import { DataGrid, Dictionary, GridColumnsConfigProvider } from '@finbeat/react-toolkit';
import DataTimeText from 'components/Common/DataTime';
import Money from 'components/Common/Money';
import { OrderLoanPayments } from 'models/api/order';
import DataGridProp from 'models/dataGridProp';
import { Trans, useTranslation } from 'react-i18next';
import { Card, CardHeader, FormGroup } from 'reactstrap';
import '../OrderInfo.scss';

type LoanPaymentsTable = DataGridProp & {
    date: string;
    payments: Dictionary<number | null>;
};

const AccrualScheduleTable = ({
    loanPayments,
    loading,
}: {
    loanPayments: OrderLoanPayments;
    loading: boolean;
}) => {
    const { t } = useTranslation();

    const rows = Object.entries(loanPayments.payments).map(([key, value]) => {
        return {
            date: key,
            payments: value,
        };
    });

    const summaryRows = rows.reduce<Dictionary<number | null>>((res, value) => {
        const paymentsArray = Object.entries(value.payments);
        paymentsArray.forEach((x) => {
            const addValue = x[1] ?? 0;
            res[x[0]] = (res[x[0]] ?? 0) + addValue;
        });

        return res;
    }, {});

    return loanPayments.services.length > 0 ? (
        <FormGroup>
            <Card className="card-for-table">
                <CardHeader>{t('BackOfficeAccrualSchedule')}</CardHeader>
                <GridColumnsConfigProvider
                    storagePath="accrual-schedule-grid"
                    initColumns={[
                        {
                            key: 'date',
                            draggable: false,
                            name: <Trans i18nKey={'BackOfficeDate'} />,
                            formatter: ({ row }) => <DataTimeText value={row.date} />,
                            summaryFormatter: () => <>{t('BackOfficeTotal')}</>,
                            summaryCellClass: 'order-info__table-summary',
                        },
                        ...loanPayments.services.map((x) => ({
                            key: x,
                            draggable: false,
                            headerCellClass: 'font-italic font-weight-normal',
                            name: x,
                            formatter: ({ row }: { row: LoanPaymentsTable }) => (
                                <Money value={row.payments[x]} />
                            ),

                            summaryFormatter: () => <Money value={summaryRows[x]} />,
                            summaryCellClass: 'order-info__table-summary',
                        })),
                    ]}
                >
                    <DataGrid<LoanPaymentsTable>
                        reactDataGreedProps={{
                            defaultColumnOptions: {
                                sortable: false,
                                resizable: false,
                            },
                            summaryRows: [{}],
                        }}
                        rows={rows}
                        blockSize={70 + (loading ? 2 : rows.length > 10 ? 10 : rows.length) * 35}
                        minBlockSize={70}
                        loading={loading}
                    />
                </GridColumnsConfigProvider>
            </Card>
        </FormGroup>
    ) : (
        <></>
    );
};

export default AccrualScheduleTable;
